import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_873411d6-41c2-4af8-9f21-deb37ae131f2/artifacts/e6ekw5ur_logo.png";

export const api = axios.create({ baseURL: API, withCredentials: true });

export function fileUrl(path) {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  return `${API}/files/${path}`;
}

export async function uploadFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const r = await api.post("/uploads", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return fileUrl(r.data.storage_path);
}

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("oh_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
